import { render, staticRenderFns } from "./SignUpInput.vue?vue&type=template&id=5861f58c&"
import script from "./SignUpInput.vue?vue&type=script&lang=js&"
export * from "./SignUpInput.vue?vue&type=script&lang=js&"
import style0 from "./SignUpInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports